import TabletViewer from './TabletViewer'
export default TabletViewer
